import { render, staticRenderFns } from "./tempValidate.vue?vue&type=template&id=0bc526f8&scoped=true"
import script from "./tempValidate.vue?vue&type=script&lang=js"
export * from "./tempValidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc526f8",
  null
  
)

export default component.exports